import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { get } from '../services/api';
import { useAuth } from './AuthContext';
import { useAsync } from './index';

const Context = createContext<{ unread: number | undefined; reload: () => void }>({
  unread: undefined,
  reload: () => {},
});
export function NotificationsProvider({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  const [tick, setTick] = useState(0);
  const result = useAsync(
    () =>
      user
        ? get<{ unreadCount: number }>('/user/notifications?perPage=1')
        : Promise.resolve({ unreadCount: 0 }),
    [user?.id, tick],
  );
  useEffect(() => {
    if (!user) return;
    const refresh = () => {
      if (document.visibilityState === 'visible') setTick((n) => n + 1);
    };
    const interval = window.setInterval(refresh, 60000);
    window.addEventListener('focus', refresh);
    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', refresh);
    };
  }, [user?.id]);
  return (
    <Context.Provider
      value={{ unread: result.error ? undefined : result.data?.unreadCount, reload: result.reload }}
    >
      {children}
    </Context.Provider>
  );
}
export const useNotifications = () => useContext(Context);
